module.exports = __webpack_public_path__ + "img/parachute.ab9446b8.svg";